import { api } from '@/endpoints/api';
import { channelApi } from '@/endpoints/channelApi';
import { scopedClientFor, type RequestScope, type ScopedClient } from './scopedTransport';

// Convenience constructors for migrated endpoint modules: every request the
// returned client issues carries the given scope explicitly and fails closed
// when the scope is missing or malformed (JS callers are not type-checked).
export const scopedApi = (scope: RequestScope): ScopedClient => scopedClientFor('api', api, scope);
export const scopedChannelApi = (scope: RequestScope): ScopedClient => scopedClientFor('channelApi', channelApi, scope);
